import {BaseValidatedClass} from '../BaseValidatedClass';

interface IconsRegistryMap {
  registerIconsSvg(_iconsMap: Record<string, string>): void;
}

export class IconsRegistry extends BaseValidatedClass implements IconsRegistryMap {
  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS: (keyof IconsRegistryMap)[] = ['registerIconsSvg'];

  constructor() {
    super(IconsRegistry.REQUIRED_METHODS, IconsRegistry);
  }

  public registerIconsSvg(_iconsMap: Record<string, string>): void {
    throw new Error('Method registerIconsSvg() must be implemented by the subclass');
  }
}
